import React, { useState } from 'react';
import ScrollerContainer from '../common/ScrollerContainer';
import SportsMenuWrapper from '../common/SportsMenuWrapper';
import StickyHeader from '../common/StickyHeader';
import TopMenu from '../common/TopMenu';
import { useUserSettings } from '../common/UserSettingsProvider';
import BannersCarousel from '../common/banners/BannersCarousel';
import { classIf } from '../data/utils/classIf';
import { usePrematchData } from '../prematch/PrematchDataProvider';
import LandingSectionProvider from './LandingSectionProvider';
import TopMatches from './TopMatches';
import Upcoming from './Upcoming';

import './style.css';
import LiveMatchesLanding from '../live/LiveMatchesLanding';
import BoostedOdds from './BoostedOdds';

export default function Landing() {
    const userSettings = useUserSettings();
    const prematchData = usePrematchData();
    const [section, setSection] = useState('highlights');

    function handleClick(e) {
        const section = e.target.getAttribute('data-section');
        setSection(section);
    }

    return (
        <LandingSectionProvider>
            <StickyHeader>
                {userSettings.showBanners &&
                    <BannersCarousel />
                }
                <TopMenu />
                <SportsMenuWrapper sports={prematchData.sport}
                                    selected={null}
                                    showBackButton={false}
                                    showEventsCount={true} />
            </StickyHeader>
            <div className="l_0">
                <div className="l_1">
                    <div className={"l_1_1" + classIf(section === 'highlights', 'selected')} onClick={handleClick} data-section={'highlights'}>Highlights</div>
                    <div className={"l_1_1" + classIf(section === 'live', 'selected')} onClick={handleClick} data-section={'live'}>Live</div>
                    <div className={"l_1_1" + classIf(section === 'upcoming', 'selected')} onClick={handleClick} data-section={'upcoming'}>Upcoming</div>
                    <div className={"l_1_1" + classIf(section === 'boosted-odds', 'selected')} onClick={handleClick} data-section={'boosted-odds'}>Boosted odds</div>
                </div>
                <ScrollerContainer>
                    <div className="l_3">
                        {(function() {
                            switch (section) {
                                default:
                                case 'highlights':
                                    return <TopMatches />;
                                case 'live':
                                    return <LiveMatchesLanding />;
                                case 'upcoming':
                                    return <Upcoming />;
                                case 'boosted-odds':
                                    return <BoostedOdds />;
                            }
                        })()}
                    </div>
                </ScrollerContainer>
            </div>
        </LandingSectionProvider>
    );
}
